import { Observable, of } from 'rxjs'

import { ReportFeatured, ConditionReport, ConditionReportState } from '@skinsoft/types'
import { conditionReportSelectors, conditionReportSearchSelectors } from '@skinsoft/selectors'
import { getDateString } from '@skinsoft/utils'

export function toReportFeatured$(report: ConditionReport, locale: string): Observable<ReportFeatured> {

    const featuredReport: ReportFeatured = {
        associatedMedias: conditionReportSelectors.medias(report),
        comments: conditionReportSelectors.comments(report, locale),
        date: dateToString(report, locale),
        firstMedia: conditionReportSelectors.firstMedia(report),
        generalState: conditionReportSelectors.generalState(report, locale),
        id: conditionReportSelectors.id(report),
        involvedItem: conditionReportSelectors.involvedItem(report),
        location: conditionReportSelectors.location(report, locale),
        originalIdentifier: conditionReportSelectors.technicsAndMaterials(report, locale),
        recommendations: conditionReportSelectors.recommendations(report, locale),
        referenceNumber: conditionReportSelectors.referenceNumber(report),
        reportReason: conditionReportSelectors.reportReason(report),
        state: conditionReportSelectors.workflowState(report) as ConditionReportState,
        technicsAndMaterials: conditionReportSelectors.technicsAndMaterials(report, locale),
    }

    return of(featuredReport)
}

export function toReportFeaturedFromSearch$(report: ConditionReport, locale: string): Observable<ReportFeatured> {

    const featuredReport: ReportFeatured = {
        associatedMedias: conditionReportSearchSelectors.medias(report),
        comments: conditionReportSearchSelectors.comments(report, locale),
        date: dateToString(report, locale),
        firstMedia: conditionReportSearchSelectors.firstMedia(report),
        generalState: conditionReportSearchSelectors.generalState(report, locale),
        id: conditionReportSearchSelectors.id(report),
        involvedItem: conditionReportSearchSelectors.involvedItem(report),
        location: conditionReportSearchSelectors.location(report, locale),
        originalIdentifier: conditionReportSearchSelectors.technicsAndMaterials(report, locale),
        recommendations: conditionReportSearchSelectors.recommendations(report, locale),
        referenceNumber: conditionReportSearchSelectors.referenceNumber(report),
        reportReason: conditionReportSearchSelectors.reportReason(report),
        state: conditionReportSearchSelectors.workflowState(report) as ConditionReportState,
        technicsAndMaterials: conditionReportSearchSelectors.technicsAndMaterials(report, locale),
    }
    
    return of(featuredReport)
}

function dateToString(conditionReport: ConditionReport, locale: string) {
    let formattedDate = ""
    const skindate = conditionReportSelectors.date(conditionReport) 
    formattedDate = getDateString(skindate, locale)

    return formattedDate
}
